// extracted by mini-css-extract-plugin
export default {"blogList":"tffuvWnThNybb7h8M8lf","blogItem":"sSkukYjy8tzUqyIm9gS9","title":"PoODFrCQ37Ghy2xrNDrv","info":"Lf9hA90cK3zIey_Xssxz"};